import { useApp } from "../context/AppContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { SYLLAPLUS_LOGO_B64 } from "../constants";

export default function ConfirmEmailChangePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { handleConfirmEmailChange } = useApp();

  const [status, setStatus] = useState("confirming"); // 'confirming' | 'success' | 'error'
  const [message, setMessage] = useState("");
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    if (!token) {
      setStatus("error");
      setMessage("This confirmation link is missing a token. Please request the email change again from Account Details.");
      return;
    }

    handleConfirmEmailChange(token).then(result => {
      setStatus(result.success ? "success" : "error");
      setMessage(result.message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ maxWidth: "400px", margin: "80px auto", padding: "0 20px", fontFamily: "sans-serif" }}>
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
          <img src={`data:image/png;base64,${SYLLAPLUS_LOGO_B64}`} alt="SyllaPlus" style={{ width: "32px", height: "32px" }} />
          <span style={{ fontSize: "22px", fontWeight: "500", color: "#1C2B3A" }}>SyllaPlus</span>
        </div>
      </div>
      <div style={{ background: "white", border: "0.5px solid #E5E7EB", borderRadius: "12px", padding: "32px 24px", textAlign: "center" }}>
        {status === "confirming" && (
          <p style={{ fontSize: "14px", color: "#6B7280" }}>Confirming your new email...</p>
        )}
        {status === "success" && (
          <>
            <p style={{ fontSize: "14px", color: "#22c55e", marginBottom: "16px" }}>{message}</p>
            <button onClick={() => navigate("/app/account")}
              style={{ padding: "11px 24px", background: "#1C2B3A", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", cursor: "pointer", fontWeight: "500" }}>
              Go to Account Details
            </button>
          </>
        )}
        {status === "error" && (
          <p style={{ fontSize: "14px", color: "#ef4444" }}>{message}</p>
        )}
      </div>
    </div>
  );
}